import u from '@/utils'
import Promise from 'bluebird'
import axios from 'axios'

const state = {
  honeyUsers: [],
  honeyUserHoneyRoles: {},
  honeyUserProfiles: {},
  userSettings: {},
  minimizeSidebar: false,
  syncUpStatus: [],
  totalUsers: 0
}

const mutations = {
  setTotalUsers(state, totalUsers) {
    state.totalUsers = totalUsers
  },

  setHoneyUsers(state, honeyUsers) {
    state.honeyUsers = honeyUsers
  },

  setUserSettings(state, userSettings) {
    state.userSettings = userSettings
  },

  setSyncUpStatus(state, syncUpStatus) {
    state.syncUpStatus = syncUpStatus
  },

  setMinimizeSidebar(state, isMini) {
    state.minimizeSidebar = isMini
  },

  toggleMenuMini(state) {
    state.minimizeSidebar = !state.minimizeSidebar
  },

  setHoneyUserHoneyRoles(state, payload) {
    state.honeyUserHoneyRoles = {
      ...state.honeyUserHoneyRoles,
      [payload.honeyUser.hexId]: payload.honeyRoles
    }
  },

  fetchHoneyUserProfiles(state, payload) {
    state.honeyUserProfiles = {
      ...state.honeyUserProfiles,
      [payload.honeyUser.hexId]: payload.profiles
    }
  }
}

const actions = {
  toggleMenuMinimize({ commit }) {
    commit('toggleMenuMini')
  },
  async fetchUserSettings({ commit }) {
    let response = await axios.get('/api/v1/honeyUsers/preferences')
    let userSettings = response.data
    commit('setUserSettings', {
      isDark: userSettings.isDark,
      theme: userSettings.theme,
      minimizeSidebar: userSettings.minimizeSidebar
    })
    commit('setMinimizeSidebar', userSettings.minimizeSidebar)
    return userSettings
  },

  async getUserCount({ commit }) {
    let response = await axios.get('/api/v1/honeyUsers/count')
    commit('setTotalUsers', response.data)
  },

  async saveUserSettings(context, data) {
    let response = await axios.post('/api/v1/honeyUsers/preferences', data)
    return response
  },

  async syncTulipUser(context, data) {
    let response = await axios.post('/api/v1/honeyUsers/syncCamunda', data)
    return response
  },

  async fixTulipUser(context, id) {
    let response = await axios.post(`/api/v1/honeyUsers/syncCamunda/${id}`, id)
    return response
  },

  async syncTulipGenericUser(context, data) {
    let response = await axios.post(
      '/api/v1/honeyUsers/initGenericAccount',
      data
    )
    return response
  },
  async syncTulipTenantCreation(context, data) {
    let response = await axios.post('/api/core/tenant/', data)
    return response
  },

  async fetchHoneyUsers({ commit }) {
    let response = await axios.get('/api/v1/honeyUsers')
    let honeyUsers = [...response.data._embedded.honeyUsers]
    honeyUsers = honeyUsers.map(honeyUser => u.processResp(honeyUser))
    commit('setHoneyUsers', honeyUsers)
    return honeyUsers
  },

  async fetchHoneyUserHoneyRoles({ commit }, honeyUser) {
    let response = await axios.get(
      `/api/v1/honeyUsers/${honeyUser.hexId}/honeyRoles`
    )
    let honeyRoles = [...response.data._embedded.honeyRoles]
    commit('setHoneyUserHoneyRoles', { honeyUser, honeyRoles })
  },

  async changeUserActivationStatus(context, payload) {
    let response = await axios.patch(
      `/api/v1/honeyUsers/${payload.hexId}`,
      payload.body
    )
    return response.data
  },

  async fetchSyncUpStatus({ commit }, urlParams) {
    let url = `/api/v1/honeyUsers/allSyncUpStatus`
    if (urlParams !== undefined && urlParams !== null) {
      url = url + '?' + urlParams
    }
    let response = await axios.get(url)
    let syncUpStatus = [...response.data]
    syncUpStatus = syncUpStatus.map(honeyUser => u.processResp(honeyUser))
    commit('setSyncUpStatus', syncUpStatus)
  },

  async fixALLTulipUser({ commit }, urlParams) {
    let url = `/api/v1/honeyUsers/syncCamunda/all`
    if (urlParams !== undefined && urlParams !== null) {
      url = url + '?' + urlParams
    }
    let response = await axios.post(url)
    let syncUpStatus = [...response.data]
    syncUpStatus = syncUpStatus.map(honeyUser => u.processResp(honeyUser))
    commit('setSyncUpStatus', syncUpStatus)
  },

  async fetchHoneyUserProfiles({ commit }, honeyUser) {
    let response = await axios.get(
      `/api/v1/honeyUsers/${honeyUser.hexId}/profiles`
    )
    let profiles = [...response.data._embedded.profiles]
    commit('fetchHoneyUserProfiles', { honeyUser, profiles })
  },

  async addProfilesToHoneyUser({ commit, dispatch }, payload) {
    let data = payload.profileIds
      .map(profileId => {
        return `/api/v1/profiles/${profileId}`
      })
      .join('\n')
    let response = await axios.put(
      `/api/v1/honeyUsers/${payload.honeyUser.hexId}/profiles`,
      data,
      {
        headers: {
          'Content-Type': 'text/uri-list'
        }
      }
    )
    return response.data
  },

  async addHoneyRoleToHoneyUser({ commit }, payload) {
    let data = payload.honeyRoles
      .map(honeyRole => {
        return `/api/v1/honeyRoles/${honeyRole.hexId}`
      })
      .join('\n')
    let response = await axios.post(
      `/api/v1/honeyUsers/${payload.honeyUser.hexId}/honeyRoles`,
      data,
      {
        headers: {
          'Content-Type': 'text/uri-list'
        }
      }
    )
    return response.data
  },

  async createBulkUser({ commit }, file) {
    let formData = new FormData()
    formData.append('file', file)
    let response = await axios.post(`/api/core/upload/userUpload`, formData, {
      headers: {
        'Content-Type': 'multipart/form-data'
      }
    })
    return response.data
  },

  deleteHoneyRoleFromHoneyUser({ commit }, payload) {
    return Promise.all(
      payload.honeyRoles.map(honeyRole => {
        return axios.delete(
          `/api/v1/honeyUsers/${payload.honeyUser.hexId}/honeyRoles/${honeyRole.hexId}`
        )
      })
    )
  }
}

export default {
  state,
  mutations,
  actions
}
